import React, { useRef } from "react"
import ImageGallery from "react-image-gallery"
import { Box, Button } from "@mui/material"

import { makeStyles } from "makeStyles"

import getImageWithSizeSuffixes from "@secureo/common/utils/commerceTools/formatters/getImageWithSizeSuffixes"

import useToggle from "@secureo/common/hooks/useToggle"

const useStyles = makeStyles()({
	thumbnail: {
		width: "100%",
		objectFit: "cover",
		height: 70,
		border: "1px solid whitesmoke",
		borderRadius: 3,
		boxShadow: "0px 0px 3px 0px rgba(0,0,0,0.15)",
		transition: "0.3s",
		"&:hover": {
			border: "1px solid #4691CE",
		},
	},
})

// https://docs.commercetools.com/http-api-projects-products#images
const formatImages = (images: string[]) => {
	const formattedImages = images.map((originalImageUrl) => {
		const { original, small, large } = getImageWithSizeSuffixes(originalImageUrl)

		return {
			original: large,
			thumbnail: small,
			fullscreen: original,
		}
	})

	return formattedImages
}

export const ImageSlider = ({ images }: Props) => {
	const { classes } = useStyles()
	const [showAll, toggleShowAll] = useToggle()
	const formattedImages = formatImages(images)

	const firstThrees = formattedImages.slice(0, 3)

	const ref = useRef(null)

	const slideToIndex = (index: number) => {
		ref?.current?.slideToIndex(index)
	}

	const isFullscreen = true

	return (
		<Box mt={2}>
			<ImageGallery
				items={formattedImages}
				useBrowserFullscreen={false}
				showFullscreenButton
				showPlayButton={false}
				showBullets={false}
				showThumbnails={isFullscreen ? true : false}
				ref={ref}
			/>
			{formattedImages.length > 1 && (
				<div style={{ display: "flex", flexWrap: "wrap" }}>
					{/* first Items */}
					{!showAll && (
						<>
							{firstThrees.map((firstThree, i) => {
								const { thumbnail } = firstThree
								return (
									<Button
										onClick={() => slideToIndex(i)}
										style={{ width: "24.4%", marginRight: 2, padding: 7 }}
										key={firstThree.thumbnail}
										disableRipple
									>
										<img
											src={thumbnail}
											alt="placeholder"
											className={classes.thumbnail}
										/>
									</Button>
								)
							})}
						</>
					)}
					{showAll && (
						<div style={{ display: "flex", flexWrap: "wrap" }}>
							{formattedImages.map((formattedImage, i) => {
								const { thumbnail } = formattedImage
								return (
									<Button
										onClick={() => slideToIndex(i)}
										style={{ width: "24.4%", marginRight: 2, padding: 7 }}
										key={formattedImage.thumbnail}
										disableRipple
									>
										<img
											src={thumbnail}
											alt="placeholder"
											className={classes.thumbnail}
											// onMouseEnter={() => slideToIndex(i)}
										/>
									</Button>
								)
							})}
							<Button
								onClick={toggleShowAll}
								style={{
									height: 74,
									border: "1px solid #B8BCBF",
									width: "24.4%",
									marginTop: 5,
									fontSize: 10,
									textTransform: "inherit",
									padding: 0,
								}}
							>
								weniger <br />
								Anzeigen
							</Button>
						</div>
					)}
					{!showAll && formattedImages.length > 3 && (
						<Button
							onClick={toggleShowAll}
							style={{
								height: 74,
								border: "1px solid #B8BCBF",
								background: "none",
								width: "24.4%",
								marginTop: 5,
							}}
						>
							+ {formattedImages.length - 3}
						</Button>
					)}
				</div>
			)}
		</Box>
	)
}

interface Props {
	images: string[]
}

export default ImageSlider
